module.exports = __webpack_public_path__ + "img/TI.c077c762.svg";